import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id D7BED84E-B592-46F0-8A5B-DD8677088837
 * name desktop-tower-monitor
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/desktop-tower-monitor.svg
 * tags
 * - Device / Tech 
 */
export const DesktopTowerMonitorIcon = createSvgIcon(<><path d="M22,18H17A1,1 0 0,1 16,17V7A1,1 0 0,1 17,6H22A1,1 0 0,1 23,7V17A1,1 0 0,1 22,18M22,8H17V9H22V8M22,10H17V11H22V10M9,15V17H10V18H5V17H6V15H2A1,1 0 0,1 1,14V7A1,1 0 0,1 2,6H13A1,1 0 0,1 14,7V14A1,1 0 0,1 13,15H9M12,8H3V13H12V8Z" /></>, 'DesktopTowerMonitorIcon');
export default DesktopTowerMonitorIcon